const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

console.log('Current API URL:', API_URL);

export { API_URL };